import { Action, createReducer, on } from '@ngrx/store';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { emailEventRuleActions } from './email-event-rule.actions';
import { EmailEventRuleItem, EmailEventRuleListResponse } from '../../../api/models';

export interface EmailEventRuleState {
  find: { state: ILoaderActionPayload; data?: EmailEventRuleListResponse };
  findOne: { state: ILoaderActionPayload; data?: EmailEventRuleItem };
  save: { state: ILoaderActionPayload; data?: EmailEventRuleItem };
  update: { state: ILoaderActionPayload; data?: EmailEventRuleItem };
  deleteRule: { state: ILoaderActionPayload };
}

const initialState: EmailEventRuleState = {
  find: { state: { value: LoadingState.NONE } },
  findOne: { state: { value: LoadingState.NONE } },
  save: { state: { value: LoadingState.NONE } },
  update: { state: { value: LoadingState.NONE } },
  deleteRule: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  on(emailEventRuleActions.find, (state) => ({ ...state, find: { state: { value: LoadingState.LOADING } } })),
  on(emailEventRuleActions.findDone, (state, { state: s, data }) => ({ ...state, find: { state: s, data } })),
  on(emailEventRuleActions.findSetState, (state, { state: s }) => ({ ...state, find: { state: s } })),

  on(emailEventRuleActions.findOne, (state) => ({ ...state, findOne: { state: { value: LoadingState.LOADING } } })),
  on(emailEventRuleActions.findOneDone, (state, { state: s, data }) => ({ ...state, findOne: { state: s, data } })),
  on(emailEventRuleActions.findOneSetState, (state, { state: s }) => ({ ...state, findOne: { state: s } })),

  on(emailEventRuleActions.create, (state) => ({ ...state, save: { state: { value: LoadingState.LOADING } } })),
  on(emailEventRuleActions.createDone, (state, { state: s, data }) => ({ ...state, save: { state: s, data } })),
  on(emailEventRuleActions.createSetState, (state, { state: s }) => ({ ...state, save: { state: s } })),

  on(emailEventRuleActions.update, (state) => ({ ...state, update: { state: { value: LoadingState.LOADING } } })),
  on(emailEventRuleActions.updateDone, (state, { state: s, data }) => ({ ...state, update: { state: s, data } })),
  on(emailEventRuleActions.updateSetState, (state, { state: s }) => ({ ...state, update: { state: s } })),

  on(emailEventRuleActions.deleteRule, (state) => ({
    ...state,
    deleteRule: { state: { value: LoadingState.LOADING } },
  })),
  on(emailEventRuleActions.deleteRuleDone, (state, { state: s }) => ({ ...state, deleteRule: { state: s } })),
  on(emailEventRuleActions.deleteRuleSetState, (state, { state: s }) => ({ ...state, deleteRule: { state: s } })),
);

export function emailEventRuleReducer(state: EmailEventRuleState | undefined, action: Action) {
  return reducer(state, action);
}
